import { cacheStore } from './store'

const key = 'sdk_token_info'

export const setSDKTokenInfo = (info: any) => {
  cacheStore.setItem(key, info)
}

export const getSDKTokenInfo = () => {
  return cacheStore.getItem(key)
}

export const removeSDKTokenInfo = () => {
  cacheStore.removeItem(key)
}

export const watchSDKTokenInfo = (callback: (info: any) => void) => {
  return cacheStore.watch(key, callback)
}
